import { render } from "./deleteRecords.vue?vue&type=template&id=a78fa0de&scoped=true"
import script from "./deleteRecords.vue?vue&type=script&lang=js"
export * from "./deleteRecords.vue?vue&type=script&lang=js"

import "./deleteRecords.vue?vue&type=style&index=0&id=a78fa0de&scoped=true&lang=css"
import "./deleteRecords.vue?vue&type=style&index=1&id=a78fa0de&lang=css"
script.render = render
script.__scopeId = "data-v-a78fa0de"

export default script